import Vue from 'vue'
import VueRouter from 'vue-router'
import BuildingsView from '../views/BuildingsView.vue'
import MetersView from '../views/MetersView.vue';
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login-view',
        component: () => import('../views/LoginView.vue'),
        meta: {
            description: "Login",
            guest: true
        }
    },
    {
        path: '/',
        name: 'buildings',
        component: BuildingsView,
        meta: {
            description: "Buildings",
            authRequired: true
        }
    },
    {
        path: '/meters',
        name: 'meters',
        component: MetersView,
        meta: {
            description: "Meters",
            authRequired: true
        }
    },
] 

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
        if (to.matched.some(r => r.meta.authRequired)) {
            if (store.getters.isAuthenticated) {
                next()
                return
            }
            next('/login')
        } else {
            next()
        }
    }
)

router.beforeEach((to, from, next) => {
        if (to.matched.some(r => r.meta.guest)) {
            if (store.getters.isAuthenticated) {
                next('/')
                return
            }
            next()
        } else {
            next()
        }
    }
)

export default router
